import styled from 'styled-components';
import { styles } from '../../consts';

const { paymentColor, boxShadow, tooltipBackground } = styles;

export const TooltipWrapper = styled.div`
  .place-top {
    &::after {
      border-top-color: ${tooltipBackground} !important;
      background-color: ${tooltipBackground} !important;
    }

    &::before {
      bottom: 0 !important;
      height: 5px !important;
    }
  }

  .place-bottom {
    margin-top: 0 !important;

    &::after {
      border-top-color: ${tooltipBackground} !important;
      background-color: ${tooltipBackground} !important;
    }
  }

  .place-left {
    &::after {
      border-left-color: ${tooltipBackground} !important;
      background-color: ${tooltipBackground} !important;
    }
  }

  .place-right {
    &::after {
      border-right-color: ${tooltipBackground} !important;
      background-color: ${tooltipBackground} !important;
    }
  }

  .__react_component_tooltip {
    background: ${tooltipBackground};
    color: ${paymentColor};
    opacity: 1 !important;
    box-shadow: 0 0.325rem 0.5rem 0 ${boxShadow};
  }
`;

export const TooltipContentWrapper = styled.div`
  width: 10.125rem;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 0.6rem;
  }
`;

export const TooltipTestInvoker = styled.div``;
